import tree from '@/components/tree.vue'
import { zzsh,dyjy } from '@/axios'
import Page from '@/components/page.vue'
import DelData from '@/components/delToast.vue'
import { Message } from 'element-ui'
import addHb from '../components/addDetail.vue'
import myTables from '@/components/tables/tables.vue'
let that;
export default{
	data(){
		return{
			getdata:{
				user_id:this.$store.state.user.userinfo.id,
				flag:this.$store.state.user.userinfo.flag,
				u_name:"",
				year:"",
				month:"",
				page:1
			},
			type:'add',
			tableData:[],
			// 活动类型列表
			typeList:[],
			totalPage:0,
			tableHeader: [     // 表头
				{prop: 'u_name', label: '党员'},
				// 如果后端传过来的值不是我们所预期的，此处可以如下判断修改，isok是是否需要渲染为el-tag,效果为下图
				{prop: 'year', label: '年份',width:"100",formatData: function (val) {
						if(that.getdata.year == '')
						return  "全部"
						else
						return  that.getdata.year
					}
				},
				{prop: 'month', label: '月份',width:"100",formatData: function (val) {
					if(that.getdata.month == '')
						return  "全部"
						else
						return  that.getdata.month
					}
				},
				{prop: 'count', label: '汇报次数',width:"160"},
				// 此处为操作栏，不需要可以删除，clickFun绑定此操作按钮的事件
				{
					prop: 'oper', label: '操作', fixed: 'right', width: '190',align:'center',
					oper: [
						{name: '查看详情', style: {color:'#bb0000'}, clickFun: this.showDetail,show:true},
						{name: '全部删除', style: {color:'#bb0000'}, clickFun: this.del,show:this.$store.state.user.userinfo.flag==3},
						{name: '上传文件', style: {color:'#bb0000'}, clickFun: this.addFiles,show:this.$store.state.user.userinfo.flag==3},
					]
				}
			],
		}
	},
	components:{tree,Page,DelData,addHb,myTables},
	mounted() {
		that.dataList();
	},
	created() {
		that = this;
	},
	methods:{
		// 数据
		dataList(){
			that.tableData = [];
			zzsh.thoughtList(that.getdata).then(res => {
				if(res.data.pagedata.length > 0){
					that.tableData = res.data.pagedata;
				}
				that.totalPage = res.data.count;
			})
		},
		// 一键提醒
		pubTixing(){
			// 一键提醒
			dyjy.sendOversee({
				dwid:that.$store.state.user.userinfo.dwid,
				zbid:that.$store.state.user.userinfo.id,
				type:5,//思想汇报，
				flag:that.$store.state.user.userinfo.flag,
			}).then(res => {
				if(res.code == 200){
					Message.success(res.msg)
				}else{
					Message.error(res.msg)
				}
			})
		},
		// 详情
		showDetail(data){
			that.$router.push({
				path:"/sxhbdetail",
				query:{
					year:that.getdata.year,
					uid:data.id
				}
			})
		},
		// 上传文件
		addFiles(data){
			that.type = 'add';
			that.$route.query.uid = data.id;
			that.$refs.addhb.openEdit();
		},
		// 部分禁用删除
		selectEnable(row, rowIndex) {
			if (row.pub_flag == that.$store.state.user.userinfo.flag&&row.pub_id == that.$store.state.user.userinfo.id) {
			  return true
			}
		 },
		// 删除
		del(data){
			if(data.count>0){
				that.$refs.delDatas.showToast(res => {
					if(res){
						zzsh.delAllThought({
							uid:data.id,
							year:that.getdata.year
						}).then(res => {
							if(res.code == 200){
								Message({
									type: 'success',
									message: '删除成功!'
								})
							}else{
								Message({
									type: 'error',
									message: res.msg
								})
							}
							that.getdata.page = 1;
							that.dataList();
						})
					}
				})
			}else{
				Message({
					type: 'warning',
					message:'没有可删除的资源'
				})
			}
		},
		// 树形结构筛选
		treeSelect(data){
			that.getdata.user_id = data.id;
			that.getdata.flag = data.flag;
			that.getdata.page = 1;
			that.dataList();
		},
		// 分页筛选
		changedata(curret){
			that.getdata.page = curret;
			that.dataList();
		},
	}
}